import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    const chartElement = this.element.querySelector("#engagement-chart");
    if (!chartElement) {
      console.error("Chart element not found!");
      return;
    }
    
    const options = {
      chart: { 
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      series: this.dataValue.series,
      xaxis: {
        categories: this.dataValue.categories,
        tickAmount: 7,
        labels: {
          rotate: -45,
          rotateAlways: false,
          hideOverlappingLabels: true,
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Activities'
        }
      },
      fill: {
        opacity: 1
      },
      colors: ['#3b82f6'],
      legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'top',
        horizontalAlign: 'left',
        floating: false,
        fontSize: '14px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontWeight: 400,
        labels: {
          colors: '#374151',
          useSeriesColors: false
        },
        markers: {
          width: 12,
          height: 12,
          radius: 2,
          offsetX: -2,
          offsetY: 0
        },
        itemMargin: {
          horizontal: 12,
          vertical: 8
        },
        onItemClick: {
          toggleDataSeries: true
        },
        onItemHover: {
          highlightDataSeries: true
        },
        containerMargin: {
          left: 0,
          top: 0
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " activities"
          }
        }
      }
    };
    
    try {
      const chart = new ApexCharts(chartElement, options);
      chart.render();
    } catch (error) {
      console.error("Error rendering chart:", error);
    }
  }
}

